import React from 'react'

const TitleRegister = ({content}) => {
  return (
    <h1>{content}</h1>
  )
}

export default TitleRegister
